import { toast } from 'vue3-toastify';

const DEFAULT_ERROR_MESSAGE = 'Une erreur est survenue.';

const MAINTENANCE_MESSAGE =
    'Le site est momentanément indisponible, une mise à jour est probablement en cours. Merci de réessayer dans quelques minutes.';

const TIMEOUT_MESSAGE =
    'Le serveur met trop de temps à répondre. Merci de réessayer dans quelques instants.';

const NETWORK_MESSAGE =
    'Impossible de joindre le serveur. Vérifiez votre connexion internet puis réessayez.';

const INFRASTRUCTURE_ERROR_MESSAGES = {
    502: MAINTENANCE_MESSAGE,
    503: MAINTENANCE_MESSAGE,
    504: TIMEOUT_MESSAGE,
    520: MAINTENANCE_MESSAGE,
    521: MAINTENANCE_MESSAGE,
    522: MAINTENANCE_MESSAGE,
    523: MAINTENANCE_MESSAGE,
    524: TIMEOUT_MESSAGE,
};

/**
 * @param {Error} [error]
 * @returns {?string}
 */
const resolveUnavailabilityMessage = (error) => {
    const status = error?.response?.status;

    if (status) {
        return INFRASTRUCTURE_ERROR_MESSAGES[status] ?? null;
    }

    if ('ECONNABORTED' === error?.code || 'ETIMEDOUT' === error?.code) {
        return TIMEOUT_MESSAGE;
    }

    if (error?.request) {
        return NETWORK_MESSAGE;
    }

    return null;
};

/**
 * @param {Error|string} [error]
 * @param {string} [fallback] - Message métier utilisé si le back-end n'en renvoie aucun.
 * @returns {string}
 */
const resolveErrorMessage = (error, fallback) => {
    if (error && 'string' === typeof error) {
        return error;
    }

    return (
        resolveUnavailabilityMessage(error) ??
        error?.response?.data?.message ??
        fallback ??
        error?.message ??
        DEFAULT_ERROR_MESSAGE
    );
};

/**
 * @param {Object|string} [response]
 * @param {string} fallback
 * @returns {string}
 */
const resolveSuccessMessage = (response, fallback) => {
    if (response && 'string' === typeof response) {
        return response;
    }

    return response?.data?.message ?? fallback;
};

/**
 * @param {Error|string} [error]
 * @param {string} [fallback]
 */
export const toastError = (error, fallback) => {
    if (error instanceof Error) {
        console.error(error);
    }

    toast.error(resolveErrorMessage(error, fallback));
};

/**
 * @param {Object|string} [response]
 */
export const toastSaved = (response) => {
    toast.success(resolveSuccessMessage(response, 'Enregistré avec succès.'));
};

/**
 * @param {Object|string} [response]
 */
export const toastCreated = (response) => {
    toast.success(resolveSuccessMessage(response, 'Ajouté avec succès.'));
};

/**
 * @param {Object|string} [response]
 */
export const toastUpdated = (response) => {
    toast.success(resolveSuccessMessage(response, 'Mis à jour avec succès.'));
};

/**
 * @param {Object|string} [response]
 */
export const toastDeleted = (response) => {
    toast.success(resolveSuccessMessage(response, 'Supprimé avec succès.'));
};

/**
 * @param {string} message
 */
export const toastSuccess = (message) => {
    toast.success(message);
};

/**
 * @param {string} message
 */
export const toastWarning = (message) => {
    toast.warning(message);
};

export const clearToasts = () => {
    toast.clearAll();
};
